import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {TranslateService} from "@ngx-translate/core";
import {HistoriqueEnveloppe,TypeNature} from "@domain/admin/entreprise/analytique/historique-enveloppe";
import {HistoriqueEnveloppeChange} from "@domain/admin/entreprise/analytique/historique-enveloppe-change";

/**
 * Composant d'affichage de la pageHistoriqueItem
 *
 * @author Lionel Gimenez
 * @date 13/02/2025
 */
@Component({
    host: {'data-test-id': 'historique-item'},
    templateUrl: './historique-item.component.html'
})
export class HistoriqueItemComponent extends ListViewItem<HistoriqueEnveloppe> {
    /** Déclaration pour le template */
    TypeNature = TypeNature;

    /** Indique si le chevron est ouvert */
    isChevronOpen: boolean = false;

    /** Constante pour optimiser le chargement de l'écran */
    videString: string = '(' + this.translateService.instant('workflow.historique.tag.value.chevron.vide') + ')';

    /**
     * Constructeur
     */
    constructor(
        private translateService: TranslateService) {
        super();
    }

    /**
     * Indique si on a la possibilité d'avoir une zone avec chevron
     * @return true si on a la possibité d'avoir une zone avec chevron
     */
    isWithChevron(): boolean {
        //Si le tableau n'est pas vide, on renvoie true
        return this.data.listeHistoriqueEnveloppeChange?.length > 0;
    }

    /**
     * Formate le log
     * @param historiqueEnveloppeChange le log courant
     * @return le log formaté
     */
    formatLog(historiqueEnveloppeChange: HistoriqueEnveloppeChange): string {
        //Si ancienneValeur est null alors on utilise la valeur videString
        const oldValue = historiqueEnveloppeChange.ancienneValeur
            ?? this.videString;
        //Si nouvelleValeur est null alors on utilise la valeur videString
        const newValue = historiqueEnveloppeChange.nouvelleValeur
            ?? this.videString;

        //Retourne une chaîne de log sous la forme "ancienne valeur -> nouvelle valeur"
        return oldValue + ' -> ' + newValue;
    }
}